import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import Slider from '@react-native-community/slider';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

interface SliderMobileProps {
  sliderWidth: number;
  C: ColorFunction;
  scale?: ScaleFunction;
  onChange: (value: number | number[]) => void;
  min: number;
  max: number;
  value: number;
  setMobileSliderOpacity: Dispatch<SetStateAction<number>>;
  mobileSliderOpacity: number;
}

const SliderMobile: FC<SliderMobileProps> = ({ sliderWidth, C, scale = initialScale, max, min, onChange, value, setMobileSliderOpacity, mobileSliderOpacity }) => {

  return (
    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
      <View style={{ width: scale(sliderWidth) }}>
        <Slider
          onLayout={() => {
            setMobileSliderOpacity(1);
          }}
          minimumValue={min}
          maximumValue={max}
          step={1}
          value={value}
          onValueChange={onChange}
          minimumTrackTintColor={C('Gray/Light/3')}
          maximumTrackTintColor={C('Gray/Light/3')}
          thumbTintColor={C('Background/Light/Field very light')}
          style={{ width: '100%' }}
        />
        <View style={{ flexDirection: 'row', width: scale(sliderWidth) }}>
          {Array.from({ length: max + 1 }).map((_, i) => (
            <View
              key={i}
              style={[
                {
                  position: 'absolute',
                  backgroundColor: C('Gray/Light/3'),
                  borderRadius: 0,
                  width: scale(4),
                  height: scale(8),
                  top: scale(-22),
                  left: (scale(sliderWidth) - scale(4)) * (i / 6),
                  zIndex: -10,
                  opacity: mobileSliderOpacity,
                },
              ]}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

export default SliderMobile;
